import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@store';
import { clearProductRiskItemState } from '../store/slices/products-form';
import {
  useLazyGetCorporateProductQuery,
  useCreateCorporateProductMutation,
  useUpdateCorporateProductMutation,
  useLazyGetProductsCorporateQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import ProductsForm from '../../partial/products/form';

const IndividualProductForm = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const {
    corporateClientsRisk: {
      products: {
        form: { item },
      },
    },
  } = useAppSelector((state) => state);

  const { productId } = useParams();
  const dispatch = useAppDispatch();

  const [getCorporateProduct, { isLoading, isFetching }] =
    useLazyGetCorporateProductQuery();
  const [createProduct, { isLoading: requestInProgress, isSuccess }] =
    useCreateCorporateProductMutation();
  const [
    updateProduct,
    { isLoading: updateInProgress, isSuccess: updateSuccess },
  ] = useUpdateCorporateProductMutation();

  const [getList] = useLazyGetProductsCorporateQuery();

  const getCorporateProductAction = useCallback(() => {
    getCorporateProduct(productId as string);
  }, [productId]);

  useEffect(() => {
    setPanelIsOpen(true);

    if (productId) {
      getCorporateProductAction();
    }

    return () => {
      dispatch(clearProductRiskItemState());
    };
  }, [dispatch, productId, getCorporateProductAction]);

  return (
    <ProductsForm
      panelIsOpen={panelIsOpen}
      setPanelIsOpen={setPanelIsOpen}
      clientType={RiskScoreClientTypeEnum.CORPORATE}
      getList={getList}
      updateProduct={updateProduct}
      createProduct={createProduct}
      isSuccess={isSuccess}
      item={item}
      isLoading={isLoading}
      requestInProgress={requestInProgress}
      updateInProgress={updateInProgress}
      updateSuccess={updateSuccess}
      isFetching={isFetching}
    />
  );
};

export default IndividualProductForm;
